module.exports = __webpack_public_path__ + "img/Service1.736b2e10.svg";